export * from './get-link-modifier';
